/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsConfirmationDetailSummaryAliases {
  AVATAR_DOCTOR = 'avatar-doctor',
  AVATAR_ICON_PAYMENT = 'avatar-icon-payment',
  BREADCRUMB = 'breadcrumb',
  BUTTON_ACTION_PAYMENT = 'button-action-payment',
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_CONFIRM = 'button-confirm',
  BUTTON_EMAIL = 'button-email',
  BUTTON_ENCOUNTER_SUMMARY = 'button-encounter-summary',
  BUTTON_INSTRUCTIONS = 'button-instructions',
  BUTTON_PAYMENT = 'button-payment',
  BUTTON_PRINT = 'button-print',
  BUTTON_QUIZ = 'button-quiz',
  BUTTON_RESCHEDULE = 'button-reschedule',
  BUTTON_RESCHEDULE_MORE = 'button-reschedule-more',
  CARD_APPOINTMENTS_DETAIL_DATE_STATE = 'card-appointments-detail-date-state',
  CARD_APPOINTMENTS_DETAIL_LOCATION = 'card-appointments-detail-location',
  CARD_APPOINTMENTS_DETAIL_PATIENT = 'card-appointments-detail-patient',
  CARD_CONTAINER_BODY_PAYMENT = 'card-container-body-payment',
  CARD_CONTAINER_PAYMENT = 'card-container-payment',
  CARD_CONTAINER_ZONE_DESCRIPTION_PAYMENT = 'card-container-zone-description-payment',
  CARD_CONTAINER_ZONE_STATUS_PAYMENT = 'card-container-zone-status-payment',
  CONTEXTUAL_BAR_DETAIL_SUMMARY = 'contextual-bar-detail-summary',
  DECK_TASK_LIST = 'deck-task-list',
  FETCH_APPOINTMENTS_DETAIL = 'fetch-appointments-detail',
  FETCH_TASK_LIST = 'fetch-task-list',
  FIELD_ADDITIONAL_INFORMATION = 'field-additional-information',
  FIELD_CATEGORY = 'field-category',
  FIELD_COMPANY = 'field-company',
  FIELD_INSURANCE_PLAN = 'field-insurance-plan',
  FIELD_PATIENT_NAME = 'field-patient-name',
  FIELD_PLAN = 'field-plan',
  FIELD_VALUE = 'field-value',
  FORM_PATIENT_NAME = 'form-patient-name',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  FRAGMENT_REFERENCE_PRINT_MODAL = 'fragment-reference-print-modal',
  FRAGMENT_STEP_LIST = 'fragment-step-list',
  HTML_VIEWER_ADDITIONAL_INFORMATION = 'html-viewer-additional-information',
  IMAGE_ICON_STATUS_PAYMENT = 'image-icon-status-payment',
  LAYOUT_APPOINTMENTS_DETAIL = 'layout-appointments-detail',
  LAYOUT_AVATAR = 'layout-avatar',
  LAYOUT_DETAIL = 'layout-detail',
  LAYOUT_DETAIL_DATE = 'layout-detail-date',
  LAYOUT_DETAIL_SUMMARY = 'layout-detail-summary',
  LOADER_REPORT = 'loader-report',
  MAP_APPOINTMENT_LOCATION = 'map-appointment-location',
  MAPPER_ADDITIONAL_INFORMATION = 'mapper-additional-information',
  PANEL_APPOINTMENTS_DETAIL = 'panel-appointments-detail',
  PANEL_DETAIL_SUMMARY = 'panel-detail-summary',
  PANEL_LOADER = 'panel-loader',
  PANEL_MAP = 'panel-map',
  PANEL_PATIENT_NAME = 'panel-patient-name',
  PANEL_PAYMENT = 'panel-payment',
  PANEL_PRINT = 'panel-print',
  PANEL_STEP_LIST = 'panel-step-list',
  PANEL_TASK_LIST = 'panel-task-list',
  REPEATER_APPOINTMENTS_DETAIL = 'repeater-appointments-detail',
  ROUTE_PRINT = 'route-print',
  TASK_LIST_SIDE_BAR_CARD = 'task-list-side-bar-card',
  TASK_TITLE = 'task-title',
  TASKS_ALERT_LINK = 'tasks-alert-link',
  TASKS_ALERT_PANEL = 'tasks-alert-panel',
  TASKS_ALERT_TOAST_NOTIFICATION = 'tasks-alert-toast-notification',
  TEXT_CATEGORY = 'text-category',
  TEXT_COMPANY = 'text-company',
  TEXT_INSURANCE_PLAN = 'text-insurance-plan',
  TEXT_PATIENT_NAME = 'text-patient-name',
  TEXT_PAYMENT_TITLE = 'text-payment-title',
  TEXT_PLAN = 'text-plan',
  TEXT_STATUS_PAYMENT = 'text-status-payment',
  TEXT_VALUE = 'text-value',
}
export { PseudonymAppointmentsConfirmationDetailSummaryAliases };
